import React, { useEffect } from "react";
import ResourcesTab from "./ResourcesTab";
import { staticURLs } from "../../config/urls";
import { Notification } from "../common/Notification";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { useAreServicesActive } from "../../util/CommonServices";
import { idfServiceIds, ezsServiceIds } from "../../config/UserServicesList";
import LogoContainer from "../common/LogoContainer";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";
import { sendRequest } from "../../util/httpClient";

const Downloads = () => {
    const dispatch = useDispatch();
    const pcProtectionService = [idfServiceIds.onlinePcProtectionTools, ezsServiceIds.onlinePcProtectionTools];
    const isPcProtectionService = useAreServicesActive(pcProtectionService);
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const partnerConfig = useSelector((state: ApplicationState) =>
        state.configurationState?.configuration.partnerConfig ? state.configurationState?.configuration.partnerConfig : null
    );
    const isPrimaryAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.accountType === "PRIMARY" ? true : false
    );

    const allowAppDownLoad = isPrimaryAccount && partnerConfig?.allowAppDownLoad;
    const partnerLegalName = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.legalName
            ? state.configurationState.configuration.partnerConfig.legalName
            : ""
    );

    const checkPartnerLegalName = partnerLegalName.includes("IdentityForce");

    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const isWhiteLabeledIdfPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 538
                ? true
                : false
            : false
    );
    const { t: tLang } = useTranslation();

    const downloadSentryBayProtectionTool = (event: any) => {
        if (event.type === "click" || (event.type === "keydown" && (event.key === " " || event.key === "Enter"))) {
            window.addToDataLayer({ event: "PC Protection Tools" });

            const requestBody = {
                "idf-user-id": "2010001527",
            };

            sendRequest("POST", `api/SentryBayOnlineProtectionTool/SentryBayOnlineProtectionTool`, requestBody, {}, true)
                .then((data: any) => {
                    if (data.status === 200) {
                        data.blob().then((blob: any) => {
                            let url = window.URL.createObjectURL(blob);
                            let a = document.createElement("a");
                            a.href = url;
                            a.download = "OnlineProtectionSuite.exe";
                            a.click();
                        });
                        Notification({
                            type: "success",
                            title: "Online PC Protection Tools",
                            message: "Online PC Protection Tools downloaded successfully.",
                        });
                    } else {
                        throw new Error(data.statusText);
                    }
                })
                .catch(function (error) {
                    Notification({
                        type: "error",
                        message: "We are currently experiencing difficulties fetching the tool, please try again later.",
                        title: "Online PC Protection Tools",
                        duration: 0,
                    });
                });
        }
    };

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="resources-downloads-page" tabIndex={-1}>
                        {tLang("resourcesSection.resourcesTitleText")}
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ResourcesTab selectedTab="8" />

            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <em className="las la-download"></em>
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">{tLang("resourcesSection.downloadsTab.tabTitle")}</h2>
                                </div>
                            </div>
                            <div className="box-actions"></div>
                        </div>
                        <div className="box-content">
                            {allowAppDownLoad && (
                                <>
                                    <h3>{tLang("resourcesSection.downloadsTab.title")}</h3>
                                    <p>{tLang("resourcesSection.downloadsTab.message")}</p>

                                    <div
                                        tabIndex={0}
                                        className="resource-container"
                                        onClick={() => {
                                            window.addToDataLayer({ event: "Download iOS App" });
                                            window.open(
                                                isBusinessUser
                                                    ? staticURLs.BusinessUseriOSApp
                                                    : checkPartnerLegalName|| isWhiteLabeledIdfPartner
                                                    ? staticURLs.IDFiOSAPP
                                                    : staticURLs.EzsiOSAPP
                                            );
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                window.addToDataLayer({ event: "Download iOS App" });
                                                window.open(
                                                    isBusinessUser
                                                        ? staticURLs.BusinessUseriOSApp
                                                        : checkPartnerLegalName || isWhiteLabeledIdfPartner
                                                        ? staticURLs.IDFiOSAPP
                                                        : staticURLs.EzsiOSAPP
                                                );
                                            }
                                        }}
                                        role="link"
                                    >
                                        <a className="resource-link">
                                            <span className="resource-icon">
                                                <em className="lab la-apple"></em>
                                            </span>
                                            <span className="resource-text" style={{ cursor: "pointer" }}>
                                                <span className="resource-title">{tLang("resourcesSection.downloadsTab.iosAppLink")}</span>
                                            </span>
                                        </a>
                                    </div>
                                    <div
                                        tabIndex={0}
                                        onClick={() => {
                                            window.addToDataLayer({ event: "Download Android App" });
                                            window.open(
                                                isBusinessUser
                                                    ? staticURLs.BusinessUserAndroidApp
                                                    : checkPartnerLegalName || isWhiteLabeledIdfPartner
                                                    ? staticURLs.IDFAndroidApp
                                                    : staticURLs.EzsAndroidApp
                                            );
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                window.addToDataLayer({ event: "Download Android App" });
                                                window.open(
                                                    isBusinessUser
                                                        ? staticURLs.BusinessUserAndroidApp
                                                        : checkPartnerLegalName|| isWhiteLabeledIdfPartner
                                                        ? staticURLs.IDFAndroidApp
                                                        : staticURLs.EzsAndroidApp
                                                );
                                            }
                                        }}
                                        className="resource-container"
                                        style={{ marginBottom: "15px" }}
                                        role="link"
                                    >
                                        <a className="resource-link">
                                            <span className="resource-icon">
                                                <em className="lab la-android"></em>
                                            </span>
                                            <span className="resource-text" style={{ cursor: "pointer" }}>
                                                <span className="resource-title">{tLang("resourcesSection.downloadsTab.androidAppLink")}</span>
                                            </span>
                                        </a>
                                    </div>
                                </>
                            )}

                            {isPcProtectionService && (
                                <>
                                    <h3>{tLang("resourcesSection.downloadsTab.protectionToolsTitle")}</h3>
                                    <p>
                                        Once installed you can change the settings or view general information by clicking on the protection shield within your
                                        system tray or your task bar.
                                    </p>
                                    <p>
                                        Your account allows you to install the Online PC Protection Tools on up to five different computers. If necessary, you may
                                        download a copy of the application again by using the download button.
                                    </p>

                                    <div className={"resource-container"}>
                                        <a
                                            className="resource-link"
                                            tabIndex={0}
                                            onClick={downloadSentryBayProtectionTool}
                                            onKeyDown={downloadSentryBayProtectionTool}
                                            role="link"
                                        >
                                            <span className="resource-icon">
                                                <em className="las la-laptop"></em>
                                            </span>
                                            <span className="resource-text">
                                                <span className="resource-title" style={{ cursor: "pointer" }}>
                                                    {tLang("resourcesSection.downloadsTab.protectionToolsSubTile")}
                                                </span>
                                                <span className="resource-description">
                                                    The latest versions of Internet Explorer, Edge, Chrome and Firefox are supported.
                                                </span>
                                            </span>
                                        </a>
                                    </div>

                                    <div className="msg-generic">
                                        <RenderIcons iconName="info-circle" /> This software will not work with Apple Macintosh products.
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Downloads;
